/* jshint esversion: 6 */
import React from 'react';

const MediaEditorButton = (props) => {

    return (
        <div className="pt-image-editor-button" role="button" aria-label='Edit Image' onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            if (props.showMediaEditor !== undefined) {
                if (props.serviceType !== undefined) {
                    props.showMediaEditor(props.fileType, props.serviceType, props.hash);
                } else {
                    props.showMediaEditor(props.fileType, 0, props.hash);
                }
            }

        }}>
            <i className="fa fa-cog"></i>
        </div>
    );
};

export default MediaEditorButton;
